import { AdminMenu } from "./AdminMenu";


const TABS = [["score", "Project score"], ["activity", "Activity responses"], ["links", "Data folders"], ["subs", "Submission status"], ["guide", "Scoring guide"]];

const fmtD = s => { const x = new Date(s.replace(" ", "T") + (s.length <= 16 ? "Z" : "")); return isNaN(x) ? s : x.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }); };
const ist = s => {
  if (!s) return null;
  const x = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : s.replace(" ", "T") + "Z");
  return isNaN(x) ? null : x.toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true }).replace(/\b(am|pm)\b/i, m => m.toUpperCase()) + " IST";
};

function Stamp({ m }) {
  if (!m) return <div className="stamp" id="stamp" data-testid="stamp">Loading data…</div>;
  const ageH = (Date.now() - new Date(m.generated)) / 36e5;
  const title = "When this dashboard last read the database" + (m.source_changed ? ". Source tables last rebuilt by the data pipeline: " + (ist(m.source_changed) || m.source_changed) : "");
  return (
    <div className="stamp" id="stamp" data-testid="stamp">
      <span title={title}>Last refreshed <b>{ist(m.generated) || fmtD(m.generated)}</b>{ageH > 30 ? <> <span className="stale">· {Math.floor(ageH / 24)} day{ageH >= 48 ? "s" : ""} old</span></> : null}</span>
    </div>
  );
}

const Who = ({ user, onLogout, onNav }) => (
  <div className={"who" + (user.is_admin ? " has-admin" : "")}>
    <div className="who-email" data-testid="user-email">Signed in as<b>{user.email}</b></div>
    {user.is_admin ? <AdminMenu onNav={onNav} onLogout={onLogout} /> : null}
    <button className="signout who-signout" onClick={onLogout} data-testid="logout-btn">Sign out</button>
  </div>
);

export function Header({ meta, tab, onTab, user, onLogout, onNav }) {
  return (
    <header className="mast">
      <div className="wrap">
        <div className="mast-row">
          <div className="brand">
            <img className="brand-logo" src="/brand/hdfc-bank-logo.svg" alt="HDFC Bank" width="193" height="38" data-testid="hdfc-logo" />
            <div className="mark mark-sym" aria-hidden="true"><img src="/brand/hdfc-bank-symbol.svg" alt="" /></div>
            <div>
              <div className="eyebrow">HDFC Bank Parivartan · Impact assessment</div>
              <h1>Impact Dashboard</h1>
            </div>
          </div>
          <div className="mast-right">{meta !== undefined ? <Stamp m={meta} /> : null}{user ? <Who user={user} onLogout={onLogout} onNav={onNav} /> : null}</div>
        </div>
        <nav className="tabs" role="tablist" aria-label="Pages">
          {TABS.map(([id, label]) => (
            <button key={id} role="tab" id={`tab-${id}`} data-tab={id} data-testid={`tab-${id}`} aria-selected={String(tab === id)} onClick={() => onTab(id)}>{label}</button>
          ))}
        </nav>
      </div>
    </header>
  );
}
